export default __webpack_public_path__ + "static/media/flag_icon_bold.9e3db334.svg";